import { render, staticRenderFns } from "./CompanionValuationsClaims.vue?vue&type=template&id=0a8ec64a&"
import script from "./CompanionValuationsClaims.vue?vue&type=script&lang=js&"
export * from "./CompanionValuationsClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports